<template>
  <VLayout :title="$t('brands.title')">
    <b-row class="letters d-flex justify-content-between">
      <div class="p-3 letter-brands" v-for="letter in letters" v-bind:key="letter">
        <router-link :to="'/brands?letter=' + letter">{{ letter }}</router-link>
      </div>
    </b-row>
    <b-row>
      <div class="p-3" v-if="letter">
        <router-link :to="'/brands'">{{ $t('brands.show_all') }}</router-link>
      </div>
    </b-row>
    <hr />
    <b-row v-if="brands.length > 0">
      <b-col class="brand" v-for="(brand, index) in brands" :key="index" cols="12" md="3">
        <router-link :to="{ path: '/category/brand', query: { brand: brand.uuid }}">{{ brand.brand }}</router-link>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>{{ $t('brands.no_exist') }}</b-col>
    </b-row>
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";

export default {
  components: {
    VLayout,
  },
  props: {
    letter: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      brands: Array,
      letters: [...Array(26)].map((e, i) => (i + 10).toString(36)),
    };
  },
  watch: {
    $route() {
      this.reload();
    },
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.loadBrands();
    },
    loadBrands() {
      this.$store
        .dispatch("drugs/REQUEST_PHDRUGS_BRANDS", { letter: this.letter })
        .then(
          response => {
            this.brands = response.data.results;
          },
          err => {
            this.$sentry({ capture: err });
            this.$router.push({ name: "fallback-error-page" });
          }
        );
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        brands: {
          title: "Brand Drugs",
          no_exist: "There are no brands",
          show_all: "Show all",
        },
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.letter-brands {
  font-size: ($font-size-medium * 1.5);
  text-transform: uppercase;
  color: $grey3-color;
}
@include media-breakpoint-down(md) {
  .letter-brands {
    font-size: $font-size-medium;
  }
}
.letters {
  display: flex;
  flex-wrap: wrap;
  color: $grey3-color;
}
.letter-brands a {
  color: $grey3-color;
}
.brand {
  text-transform: uppercase;
  font-size: $font-size-medium;
  a {
    color: $grey3-color;
  }
}
</style>

